/**
 * Search History Types & Utilities
 * DEPRECATED: Most functionality moved to Zustand store (searchSlice.ts)
 * Only type definition and utility function remain for compatibility
 */

import { useGeoMarkupStore } from '../store';

export interface SearchHistoryItem {
  id: string;
  display_name: string;
  coordinates: {
    lat: number;
    lng: number;
  };
  timestamp: number;
  type?: string;
}

/**
 * Check if a search display name exists in recent searches
 * Used by SearchResultItem to show clock icon for recent searches
 * Accesses Zustand store directly to avoid prop drilling
 *
 * @param displayName - The display name to check
 * @returns true if search exists in recent searches
 */
export const isInRecentSearches = (displayName: string): boolean => {
  const recentSearches = useGeoMarkupStore.getState().search.recentSearches;
  return recentSearches.some(search => search.display_name === displayName);
};
